const commonReducer = (state = {}, action) => {
  switch (action.type) {
    case "MENU_TOGGLE":
      return Object.assign({}, state, {
        menuToggle: action.data,
      });
    case "SIDE_PANEL":
      return Object.assign({}, state, {
        sidePanel: action.data,
      });
    case "HISTORY_LOG":
      return Object.assign({}, state, {
        historyLog: action.data,
      });
    case "SHOW_LOADER":
      return Object.assign({}, state, {
        loading: action.data,
      });
    case "SETTINGS":
      return Object.assign({}, state, {
        settings: action.data,
      });
    case "WEIGHT_CALCULATION":
      return Object.assign({}, state, {
        weight: action.data,
      });
    case "SD":
      return Object.assign({}, state, {
        addNewSd: action.data,
      });
    case "CANCEL":
      return Object.assign({}, state, {
        alertCancel: action.data,
      });
    default:
      return state;
  }
};

export default commonReducer;